<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            @click="addPermission"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-plus">
            Thêm chức năng
          </vs-button>
        </div>
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
      </div>
      <!-- AgGrid Table -->
      <iframe  style = "width:100%; height:100vh" frameborder="0" scrolling="no" src = "https://103.143.206.71:5601/app/kibana#/home"></iframe>
    </div>
  </div>
</template>

<script>
  import {AgGridVue} from "ag-grid-vue"
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import CellRendererActions from "./cell-renderer/CellRendererActions.vue"

  export default {
    components: {
      AgGridVue,
      CellRendererActions,
    },
    data() {
      return {
        searchQuery: "",
        maxPageNumbers: 6,
        gridApi: null,
        gridOptions: {},
        defaultColDef: {},
        columnDefs: [
          {
            headerName: 'ID',
            field: 'id',
            width: 70
          },
          {
            headerName: 'Tên chức năng',
            field: 'functionName',
            width: 150
          },
          {
            headerName: 'Alias',
            field: 'functionAlias',
            width: 150
          },
          {
            headerName: 'API Path',
            field: 'functionApiPrefix',
            width: 200
          },
          {
            headerName: 'Screen Path',
            field: 'functionScreenPrefix',
            width: 200,
          },
          {
            headerName: 'Hành động',
            field: 'transactions',
            width: 100,
            cellRendererFramework: 'CellRendererActions',
          },
        ],
        components: {
          CellRendererActions,
        },
        permissionList: []
      }
    },
    created() {
      this.initScreen();
    },
    watch: {
      '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          // this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          // this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdatePermission'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_PERMISSION_SUCCESS', false);
        }
      },
    },
    computed: {
      totalPages() {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      updateSearchQuery(val) {
        this.gridApi.setQuickFilter(val)
      },
      addPermission() {
        this.$router.push('/admin/manage-permission/add').catch(() => {
        })
      },
      onGridReady() {
        if (this.$store.state.windowWidth <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      initScreen() {
        this.$vs.loading();
        this.$business.post('/permission/all').then((response) => {
          this.permissionList = response.data;
          this.$vs.loading.close();
          setTimeout(() => {
            if (this.$store.state.windowWidth > 1024) {
              this.gridApi.sizeColumnsToFit();
            }
          }, 100);
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
    }
  }
</script>

<style scoped>

</style>
